var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemplateicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9585 0.916016H2.75016C2.50705 0.916016 2.27389 1.01259 2.10198 1.1845C1.93007 1.35641 1.8335 1.58957 1.8335 1.83268V9.16602C1.8335 9.40913 1.93007 9.64229 2.10198 9.8142C2.27389 9.9861 2.50705 10.0827 2.75016 10.0827H8.25016C8.49328 10.0827 8.72644 9.9861 8.89834 9.8142C9.07025 9.64229 9.16683 9.40913 9.16683 9.16602V4.12435L5.9585 0.916016Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9585 0.916016V4.12435H9.16683",
    fill: "#FF6B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateicon);
export default __webpack_public_path__ + "static/media/templateicon.ac64866aab471f6f11f9e7f56bba3fe7.svg";
export { ForwardRef as ReactComponent };